import createClient from '../../helpers/api-client';

const storeSuffix = 'MyPagesCustomer';

// ACTIONS
// customer actions
export const FETCH_CUSTOMER_BY_ID = `fetchCustomerByIdAction${storeSuffix}`;
export const UPDATE_CUSTOMER_ACCOUNT_INFO = `updateCustomerAccountInfoAction${storeSuffix}`;
export const SAVE_CUSTOMER_ACCOUNT_INFO = `saveCustomerAccountInfoAction${storeSuffix}`;
export const SAVE_CUSTOMER_PASSWORD = `saveUserCompanyPasswordAction${storeSuffix}`;
export const TOGGLE_REQUEST_STATUS = `toggleRequestStatusAction${storeSuffix}`;

// MUTATIONS
// customer mutations
export const BEGIN_FETCH_CUSTOMER = `beginFetchCustomerMutation${storeSuffix}`;
export const RECEIVED_CUSTOMER = `receivedCustomerMutation${storeSuffix}`;
export const CUSTOMER_NOT_FOUND = `customerNotFoundMutation${storeSuffix}`;
export const CHANGE_CUSTOMER_ACCOUNT_INFO = `changeCustomerAccountInfoMutation${storeSuffix}`;
export const REQUEST_UPDATED = `requestUpdatedMutation${storeSuffix}`;
export const RESET_STATE = `resetStateMutation${storeSuffix}`;

//save mutations
export const BEGIN_SAVE = `beginSaveMutation${storeSuffix}`;
export const SAVE_COMPLETED = `saveCompletedMutation${storeSuffix}`;
export const SAVE_ERROR = `saveErrorMutation${storeSuffix}`;

// GETTERS
// global getters
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

// save getters
export const GET_SAVE_ERROR = `getSaveErrorGetter${storeSuffix}`;

// customer getters
export const GET_CUSTOMER_DATA = `getCustomerDataGetter${storeSuffix}`;

export const modelState = () => ({
    myPagesCustomer: {
        isLoading: true,
        error: null,
        saveErrors: {
            accountInfo: null,
            password: null,
        },
        data: {},
    },
});

export const actions = {
    // customer actions
    [FETCH_CUSTOMER_BY_ID]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH_CUSTOMER);

            try {
                const res = await apiClient.get(`/api/my-pages/customer`);
                commit(RECEIVED_CUSTOMER, res);

                resolve(res);
            } catch (error) {
                let message = 'Något gick fel. Ladda om sidan';
                commit(CUSTOMER_NOT_FOUND, message);
                reject(error);
            }
        });
    },
    [TOGGLE_REQUEST_STATUS]: ({ state, commit }, request) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            // No loaders or error handling is really needed so let's keep this simple...

            let data = {
                Activate: false,
            };
            if (!request.Active) {
                data.Activate = true;
            }

            try {
                const res = await apiClient.post(
                    `/api/request/${request.Id}/status`,
                    data
                );
                commit(REQUEST_UPDATED, {
                    request: request,
                    activate: data.Activate,
                });
                resolve(res);
            } catch (error) {
                // Fail silently :S
                reject(error);
            }
            resolve();
        });
    },
    [UPDATE_CUSTOMER_ACCOUNT_INFO]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            commit(CHANGE_CUSTOMER_ACCOUNT_INFO, data);
            resolve();
        });
    },
    [SAVE_CUSTOMER_ACCOUNT_INFO]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'accountInfo');

            let data = {
                Name: state.myPagesCustomer.data.User.Name,
                Email: state.myPagesCustomer.data.User.Email,
                Phone: state.myPagesCustomer.data.User.Phone,
                Newsletter: state.myPagesCustomer.data.User.Newsletter,
            };

            try {
                const res = await apiClient.post(
                    `/api/my-pages/customer/account`,
                    data
                );
                commit(SAVE_COMPLETED, 'accountInfo');

                resolve(res);
            } catch (error) {
                let message = 'Något gick fel.';
                commit(SAVE_ERROR, { key: 'accountInfo', error: message });
                reject(error);
            }
        });
    },
    [SAVE_CUSTOMER_PASSWORD]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'password');

            try {
                const res = await apiClient.post(
                    `/api/my-pages/update-password`,
                    data
                );
                commit(SAVE_COMPLETED, 'password');

                resolve(res);
            } catch (error) {
                commit(SAVE_ERROR, { key: 'password', error: error.Message });
                reject(error);
            }
        });
    },
};

export const mutations = {
    // customer mutations
    [BEGIN_FETCH_CUSTOMER]: state => {
        state.myPagesCustomer.isLoading = true;
        state.myPagesCustomer.error = false;
    },
    [RECEIVED_CUSTOMER]: (state, payload) => {
        const { data } = payload;
        state.myPagesCustomer.data = data;
        state.myPagesCustomer.isLoading = false;
        state.myPagesCustomer.error = false;
    },
    [CUSTOMER_NOT_FOUND]: (state, payload) => {
        state.myPagesCustomer.isLoading = false;
        state.myPagesCustomer.error = payload;
    },
    [CHANGE_CUSTOMER_ACCOUNT_INFO]: (state, payload) => {
        Object.keys(payload).forEach(function(key) {
            if (state.myPagesCustomer.data.User.hasOwnProperty(key)) {
                const customer = state.myPagesCustomer.data.User;
                customer[key] = payload[key];
                state.myPagesCustomer.data.User = customer;
                return;
            }
        });
    },
    [REQUEST_UPDATED]: (state, { request, activate }) => {
        const requestIndex = state.myPagesCustomer.data.Requests.findIndex(
            r => {
                return r.Id === request.Id;
            }
        );
        state.myPagesCustomer.data.Requests[requestIndex].Active = activate;
    },

    // save mutations
    [BEGIN_SAVE]: (state, key) => {
        state.myPagesCustomer.saveErrors[key] = null;
    },
    [SAVE_COMPLETED]: (state, key) => {
        state.myPagesCustomer.saveErrors[key] = null;
    },
    [SAVE_ERROR]: (state, { key, error }) => {
        state.myPagesCustomer.saveErrors[key] = error;
    },
    [RESET_STATE]: state => {
        state.myPagesCustomer.data = {};
    }
};

export const getters = {
    // global getters
    [IS_LOADING]: state => {
        return state.myPagesCustomer.isLoading;
    },
    [GET_ERROR]: state => {
        return state.myPagesCustomer.error;
    },

    // save getters
    [GET_SAVE_ERROR]: state => {
        return key => {
            return state.myPagesCustomer.saveErrors[key];
        };
    },

    // customer getters
    [GET_CUSTOMER_DATA]: state => {
        return state.myPagesCustomer.data;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/my-pages-customer-model.js